import { shallowRef, ref, computed } from 'vue'
import { useTemplate } from '../../../hooks/index'
import { setValueByPathToVue } from '../../../utils/index'

export function useCriteriaGroups(groupReload) {
  const { getTemplateData, compileData } = useTemplate()
  const groupsForm = shallowRef(null)
  const groupsData = ref({})
  const onlyShowFieldsByKey = {}
  const onlyShowFields = computed(() => {
    const fields = []
    const keys = Object.keys(groupsData.value)
    for (const key of keys) {
      if (groupsData.value[key] === true) {
        fields.push(...onlyShowFieldsByKey[key])
      }
    }
    return [...new Set(fields)]
  })
  //更新 groupsData 的选中数据
  const updateGroupsData = (data) => {
    if (!groupsForm.value?.items || groupsForm.value?.items?.length <= 0) return
    groupsForm.value.items.forEach((element) => {
      if (data[element.property] != undefined && data[element.property] == true) {
        setValueByPathToVue(groupsData.value, element.property, true)
      } else {
        setValueByPathToVue(groupsData.value, element.property, false)
      }
    })
  }
  const setGroupsForm = (resData, searchData) => {
    const templateData = getTemplateData()
    //增加查询事件（当值改变时触发查询）
    const query = (val, property) => {
      setValueByPathToVue(groupsData.value, property, val)
      if (!groupReload) {
        return
      }
      searchData()
    }
    groupsForm.value = {
      code: resData.criteria?.code,
      id: resData.criteria?.id,
      form: {
        property: {
          formGroup: false,
        },
      },
      items: resData.groups.map((im) => {
        if (!im.parameter) im.parameter = {} //初始化parameter
        if (!im.component?.code) {
          im.component = { code: 'PgCheckbox' }
        }
        if (im.component?.code === 'PgCheckbox') {
          im.parameter.text = im.label
          im.label = ''
        }
        if (im.chosen) {
          setValueByPathToVue(groupsData.value, im.property, true)
        }
        if (im.defaultValue) {
          setValueByPathToVue(
            groupsData.value,
            im.property,
            compileData(im.defaultValue, templateData)
          )
        }
        if (im.parameter.onlyShowFields) {
          onlyShowFieldsByKey[im.property] = im.parameter.onlyShowFields
          delete im.parameter.onlyShowFields
        }
        //增加查询事件（当值改变时触发查询）
        im.parameter.event = {
          change: (val) => query(val, im.property),
          'on-change': (val) => query(val, im.property),
        }
        return im
      }),
    }
  }

  return {
    groupsForm,
    groupsData,
    onlyShowFields,
    setGroupsForm,
    updateGroupsData,
  }
}
